export interface PagamentoTitulo {
  CE1FILIAL: string;
  CE1PREFIXO: string;
  CE1NUM: string;
  CE1PARCELA: string;
  CE1TIPO: string;
  CE1CLIENTE: string;
  CE1LOJA: string;
  CE1NOMCLI: string;
  CE1HIST: string;
  CE1SITUACA: string;
  DE1EMISSAO: Date | undefined;
  DE1VENCTO: Date | undefined;
  DE1VENCREA: Date | undefined;
  NE1VALOR: number;
  NE1SALDO: number;
}

export const defaultPagamentoTitulo = (): PagamentoTitulo => {
  return {
    CE1FILIAL: '',
    CE1PREFIXO: '',
    CE1NUM: '',
    CE1PARCELA: '',
    CE1TIPO: '',
    CE1CLIENTE: '',
    CE1LOJA: '',
    CE1NOMCLI: '',
    CE1HIST: '',
    CE1SITUACA: '',
    DE1EMISSAO: undefined,
    DE1VENCTO: undefined,
    DE1VENCREA: undefined,
    NE1VALOR: 0,
    NE1SALDO: 0,
  }
}

export interface PagamentoTituloLista {
  items: Array<PagamentoTitulo>;
}

export const defaultPagamentoTituloLista = (): PagamentoTituloLista => {
  return {
    items: []
  }
}
